// extracted by mini-css-extract-plugin
export default {"Blog":"BlogSwitcher_Blog__vGm3M"};